import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function LegacyEntityBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Record Batch" />;
}
